import styled from 'styled-components';

import { WHITE, CHART_SUBTITLE_COLOR, BLACK } from '../../../utils/colors';
import { Axes as AxesComponent } from '../axes';

export const Legend = styled.div`
  flex: 0 auto;
  font-family: sans-serif;
  font-size: 0.6em;
  color: ${CHART_SUBTITLE_COLOR};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 200px;
`;

export const LegendLabels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
`;

export const LegendItem = styled.span`
  text-transform: uppercase;
  max-width: 50px;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2em;
  margin-bottom: 3px;

  :last-child {
    text-align: right;
  }
`;

export const ScaleBar = styled.div`
  display: flex;
  height: 8px;
  width: 100%;
  background: ${({ colors: [worse, mid, better] }) => `linear-gradient(90deg, ${worse}, ${mid}, ${better})`};
`;

export const Axes = styled(AxesComponent)`
  .vx-axis-bottom .vx-axis-tick:first-child {
    display: none;
  }
`;

export const BubbleText = styled.text`
  font-family: sans-serif;
  fill: ${WHITE};
  text-anchor: middle;
  line-height: 1em;
`;

export const bubbleLabelStyle = {
  fontSize: '0.55em',
  fontWeight: 'bold',
  fontFamily: 'sans-serif',
};

export const BubbleLabel = styled(BubbleText)`
  font-size: ${bubbleLabelStyle.fontSize};
  transform: ${({ scale }) => `scale(${scale}) translateY(-4px)`};
  fill: ${({ isBlack }) => (isBlack ? BLACK : WHITE)};
`;

export const bubbleValueStyle = {
  fontSize: '1em',
  fontWeight: 'bold',
  fontFamily: 'sans-serif',
};

export const BubbleValue = styled(BubbleText)`
  font-size: ${bubbleValueStyle.fontSize};
  font-weight: ${bubbleValueStyle.fontWeight};
  transform: ${({ scale, yValueOffset }) => `scale(${scale}) translateY(${yValueOffset}px)`};
  fill: ${({ isBlack }) => (isBlack ? BLACK : WHITE)};
`;

export const BubbleCounterLabel = styled(BubbleText)`
  font-size: ${bubbleLabelStyle.fontSize};
  transform: ${({ scale, yValueOffset }) => `scale(${scale}) translateY(${yValueOffset}px)`};
  fill: ${({ isBlack }) => (isBlack ? BLACK : WHITE)};
`;
